<template>
  <div>
    <template v-if="isLoading">
      <SkeletonLoader
        class="loader-skeleton"
        data-testid="loader-skeleton-buttons"
      >
        <div
          v-for="(_button, index) in buttons"
          :key="index"
          class="loader-button"
        />
      </SkeletonLoader>
    </template>
    <template v-else>
      <WealthChartAction
        v-for="(button, index) in buttons"
        :key="index"
        class="wealth-chart-action"
        :disabled="!button.enabled"
        :label="button.label"
        :data-testid="`wealth-action-${button.action.type}`"
        @click="handleButtonClick(button.action.type)"
      />
    </template>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Vue,
  Prop
} from 'vue-property-decorator';
import { WealthChartAction } from '@/modules/wealth/components/WealthChartAction';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';
import { trackGoToInvestmentFlow, trackWealthWithdraw } from '../../track-events';
import { IWealthHeroButtonType, IWealthHeroResponse } from '@/modules/wealth/services/investment/investment-types';

@Component({
  components: { WealthChartAction, SkeletonLoader }
})
export default class WealthViewActions extends Vue {
  @Prop({ type: Boolean, required: true })
  private isCustomerOverdue!: boolean;

  @Prop({ type: Array, required: true })
  private buttons!: IWealthHeroResponse['buttons'];

  @Prop({ type: Boolean, required: true })
  private isLoading!: boolean;

  handleButtonClick(buttonType: IWealthHeroButtonType) {
    switch (buttonType) {
      case IWealthHeroButtonType.GO_TO_INVESTMENT:
        this.goToInvestmentFlow();
        break;
      case IWealthHeroButtonType.GO_TO_REDEMPTION:
        trackWealthWithdraw();
        this.$router.push({
          name: 'wealthWithdraw'
        });
        break;
    }
  }

  private goToInvestmentFlow() {
    trackGoToInvestmentFlow();

    if (this.isCustomerOverdue) {
      return this.$router.push({
        name: 'regulatoryUpdateAnnouncement'
      });
    }

    this.$router.push({
      name: 'investment',
      query: {
        cameFrom: 'wealth'
      }
    });
  }
}
</script>

<style lang="less" scoped>
.loader-skeleton {
  display: flex;
}

.loader-button {
  width: 156px;
  height: 48px;
  margin-right: @size-spacing-x450;
  border-radius: @size-radius-x200;
}

.wealth-chart-action {
  margin-right: @size-spacing-x350;
  margin-bottom: @size-spacing-x350;
}
</style>
